import React from 'react';
import {SecondaryCollapsibleSection} from "../../../../../../../elements/collapsableSection/secondary/SecondaryCollapsibleSection";
import {ValidationResult} from "../../../../../../../elements/validator/component/ValidationComponent";
import {SubtractionLine} from "../SubtractionLine/SubtractionLine";
import {DependantValidationComponent} from "../../../../../../../elements/validator/dependant/DependantValidationComponent";
import {ConditionMultipliersRequestValidator} from "../../../../../../../elements/validator/Validator";
import {
    selectConditionMultipliers,
    selectExcellentSubtraction,
    selectGoodSubtraction,
    selectAverageSubtraction,
    selectBelowAverageSubtraction,
    selectPoorSubtraction
} from "../../../toolSettingsSlice";
import {UpdateBotToolSettingsRequest, UpdateConditionMultipliersRequest, UpdateSubtractionRequest} from "../../../../../../../../api/generated";
import styles from "./VehicleConditionDiscount.module.css";

interface Props {
    getMessage: (f: string) => string;
    updateValidationStatus: (status: ValidationResult<UpdateBotToolSettingsRequest>) => void;
    updateConditionMultipliers: (fieldName: string, value: UpdateSubtractionRequest) => void;
    disabled?: boolean;
}

export const VehicleConditionDiscount: React.FC<Props> = ({
    getMessage,
    updateValidationStatus,
    updateConditionMultipliers,
    disabled
}) => {
    const getErrorMessageForField = (fieldName: string): string | undefined => {
        const rawErrors = getMessage("conditionMultipliers");
        if (rawErrors) {
            try {
                return JSON.parse(rawErrors)[fieldName];
            } catch (e) {
                // Ignore JSON parse errors
            }
        }
        return undefined;
    };

    return (
        <DependantValidationComponent<UpdateConditionMultipliersRequest, UpdateBotToolSettingsRequest>
            onChange={v => v}
            updateValidationStatus={updateValidationStatus}
            fieldName={'conditionMultipliers'}
            required={false}
            selector={selectConditionMultipliers}
            validator={ConditionMultipliersRequestValidator}
            label={"Condition Multipliers"}
            disabled={disabled}
            anchorValueSelector={(state) => state.toolSettings.updateRequest.botPublicId}
            child={() =>
                <SecondaryCollapsibleSection disabled={disabled} title={"Vehicle Condition Discount"}>
                    <div className={styles.wrapper}>
                        <SubtractionLine
                            title={"If condition is Excellent"}
                            fieldName={"excellentSubtraction"}
                            errorMessage={getErrorMessageForField("excellentSubtraction")}
                            subtractionFieldSelector={selectExcellentSubtraction}
                            updateMultipliers={updateConditionMultipliers}
                            disabled={disabled}
                        />
                        <SubtractionLine
                            title={"If condition is Good"}
                            fieldName={"goodSubtraction"}
                            errorMessage={getErrorMessageForField("goodSubtraction")}
                            subtractionFieldSelector={selectGoodSubtraction}
                            updateMultipliers={updateConditionMultipliers}
                            disabled={disabled}
                        />
                        <SubtractionLine
                            title={"If condition is Average"}
                            fieldName={"averageSubtraction"}
                            errorMessage={getErrorMessageForField("averageSubtraction")}
                            subtractionFieldSelector={selectAverageSubtraction}
                            updateMultipliers={updateConditionMultipliers}
                            disabled={disabled}
                        />
                        <SubtractionLine
                            title={"If condition is Below Average"}
                            fieldName={"belowAverageSubtraction"}
                            errorMessage={getErrorMessageForField("belowAverageSubtraction")}
                            subtractionFieldSelector={selectBelowAverageSubtraction}
                            updateMultipliers={updateConditionMultipliers}
                            disabled={disabled}
                        />
                        <SubtractionLine
                            title={"If condition is Poor"}
                            fieldName={"poorSubtraction"}
                            errorMessage={getErrorMessageForField("poorSubtraction")}
                            subtractionFieldSelector={selectPoorSubtraction}
                            updateMultipliers={updateConditionMultipliers}
                            withBorderLine={false}
                            disabled={disabled}
                        />
                    </div>
                </SecondaryCollapsibleSection>
            }
        />
    );
};

